import React, { Component } from 'react';
import { Container, Row, Col } from 'reactstrap';
import api from '../utils/api';
import { LabOrderFormDownload } from "../components/LabOrderFormDownload";
import helpers from '../utils/helpers';
// import { Link, Redirect } from 'react-router-dom';
// import classnames from 'classnames';

export class DownloadLabForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      labFormDataId: null
    };
    this.loadData = this.loadData.bind(this);
  }

  componentDidMount() {
    if (this.props.currentUser) {
      this.loadData();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.currentUser && (!prevProps.currentUser || (prevProps.currentUser.id !== this.props.currentUser.id))) {
      this.loadData();
    }
  }

  loadData() {
    // true disables caching
    api.getUserHomeData(true).then(data => {
      this.setState({
        labFormDataId: data.labFormDataId
      });
    }).catch(helpers.catchHandler);
  }

  render() {
    return (
      <Container fluid>
        <Row>
          <Col md={{offset: 2, size: 8}} sm="12">
            <LabOrderFormDownload 
              labFormDataId={this.state.labFormDataId}
              isBBT={this.props.currentUser.isBBT}
              isTEL={this.props.currentUser.isTEL}
              isTELSpouse={this.props.currentUser.isTELSpouse}
              isSunTrust={this.props.currentUser.isSunTrust}
            />
          </Col>
        </Row>
      </Container>);
  }
}